export default {
  sections: [
    {
      id: 'property',
      title: 'Property Details',
      fields: [
        {
          id: 'address',
          type: 'textarea',
          label: 'Property Address',
          required: true
        },
        {
          id: 'landlord',
          type: 'text',
          label: 'Landlord/Agent Name',
          required: true
        },
        {
          id: 'tenant',
          type: 'text',
          label: 'Tenant Name'
        },
        {
          id: 'inspectionDate',
          type: 'date',
          label: 'Inspection Date',
          required: true
        }
      ]
    },
    {
      id: 'engineer',
      title: 'Engineer Details',
      fields: [
        {
          id: 'engineerName',
          type: 'text',
          label: 'Engineer Name',
          required: true
        },
        {
          id: 'electricalRegNumber',
          type: 'text',
          label: 'Electrical Registration Number',
          required: true
        },
        {
          id: 'company',
          type: 'text',
          label: 'Company Name'
        },
        {
          id: 'phone',
          type: 'tel',
          label: 'Phone Number'
        }
      ]
    },
    {
      id: 'circuits',
      title: 'Electrical Circuits',
      repeatable: true,
      fields: [
        {
          id: 'circuitType',
          type: 'select',
          label: 'Circuit Type',
          required: true,
          options: ['Lighting', 'Power', 'Cooker', 'Shower', 'Immersion Heater', 'Other']
        },
        {
          id: 'location',
          type: 'text',
          label: 'Location',
          required: true
        },
        {
          id: 'rating',
          type: 'text',
          label: 'Rating (Amps)'
        },
        {
          id: 'protectiveDevice',
          type: 'select',
          label: 'Protective Device',
          required: true,
          options: ['RCBO', 'RCD', 'MCB', 'Fuse']
        },
        {
          id: 'testResult',
          type: 'select',
          label: 'Test Result',
          required: true,
          options: ['Satisfactory', 'Unsatisfactory', 'Not Tested']
        },
        {
          id: 'remedialAction',
          type: 'textarea',
          label: 'Remedial Action Required'
        }
      ]
    },
    {
      id: 'certification',
      title: 'Certification',
      fields: [
        {
          id: 'nextInspectionDate',
          type: 'date',
          label: 'Next Inspection Due',
          required: true
        },
        {
          id: 'certificateNumber',
          type: 'text',
          label: 'Certificate Number',
          required: true
        },
        {
          id: 'engineerSignature',
          type: 'text',
          label: 'Engineer Signature'
        },
        {
          id: 'additionalNotes',
          type: 'textarea',
          label: 'Additional Notes'
        }
      ]
    }
  ]
};